const getTitleMostPopularSuperLikedSampleSelectUtil = memberFirstName => `${memberFirstName}’s most popular superliked sample`

export default getTitleMostPopularSuperLikedSampleSelectUtil
